import { c as _c } from "react/compiler-runtime";
import styles from "./BlockTables.module.scss";
import { CSSProperties } from "react";
import { BlockTableContents, BlockTablesContent, TableConfiguration } from "./BlockTablesContent";
type BlockTableConfig = {
  title?: string;
  subtitle?: string;
  containertype?: "column" | "full" | "fixed";
  fixedwidth?: number;
};
type BlockTablesTable = {
  configuration: TableConfiguration;
  contents: BlockTableContents;
};
export const BlockTables: React.FC<{
  config: BlockTableConfig;
  tables: BlockTablesTable[];
  columnWidths?: number[];
}> = t0 => {
  const $ = _c(20);
  const {
    config,
    tables,
    columnWidths
  } = t0;
  if (!config) {
    return null;
  }
  let classes;
  if ($[0] !== config.containertype || $[1] !== config.title) {
    classes = [styles.blockTable];
    if (config.containertype === "column") {
      classes.push(styles.column);
    } else {
      if (config.containertype === "full") {
        classes.push(styles.full);
      } else {
        if (config.containertype === "fixed") {
          classes.push(styles.fixed);
        }
      }
    }
    if (config.title) {
      classes.push(styles.hasTitle);
    }
    $[0] = config.containertype;
    $[1] = config.title;
    $[2] = classes;
  } else {
    classes = $[2];
  }
  let setStyles;
  if ($[3] !== config.containertype || $[4] !== config.fixedwidth) {
    setStyles = {};
    if (config.containertype === "fixed") {
      setStyles.width = `${config.fixedwidth}rem`;
    }
    $[3] = config.containertype;
    $[4] = config.fixedwidth;
    $[5] = setStyles;
  } else {
    setStyles = $[5];
  }
  const t1 = classes.join(" ");
  let t2;
  if ($[6] !== config.subtitle || $[7] !== config.title) {
    t2 = config.title && <div className={styles.titles}><h5>{config.title}</h5><span>{config.subtitle}</span></div>;
    $[6] = config.subtitle;
    $[7] = config.title;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== columnWidths || $[10] !== setStyles || $[11] !== tables) {
    t3 = tables && tables.map((table, index) => <BlockTablesContent key={index} config={table.configuration} contents={table.contents} fixedStyles={setStyles} fixedWidths={columnWidths} />);
    $[9] = columnWidths;
    $[10] = setStyles;
    $[11] = tables;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <div className={styles.contentsWrapper}>{t3}</div>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== setStyles || $[16] !== t1 || $[17] !== t2 || $[18] !== t4) {
    t5 = <div className={t1} style={setStyles}>{t2}{t4}</div>;
    $[15] = setStyles;
    $[16] = t1;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};